<template>
    <div class="w-full">
      <h3 class="mb-4 font-semibold text-gray-900">Tipo</h3>
      <ul class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex">
        <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r">
          <div class="flex items-center ps-3">
            <input
              :id="'type-box-' + suffix"
              type="radio"
              value="Caja"
              v-model="localType"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
            >
            <label :for="'type-box-' + suffix" class="w-full py-3 ms-2 text-sm font-medium text-gray-900">
              Caja
            </label>
          </div>
        </li>
        <li class="w-full">
          <div class="flex items-center ps-3">
            <input
              :id="'type-cash-' + suffix"
              type="radio"
              value="Efectivo"
              v-model="localType"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
            >
            <label :for="'type-cash-' + suffix" class="w-full py-3 ms-2 text-sm font-medium text-gray-900">
              Efectivo
            </label>
          </div>
        </li>
      </ul>
  
      <div class="flex flex-wrap mt-4">
        <text-input
          v-model="localCondition"
          :error="errors[`condition${suffix ? '_' + suffix : ''}`]"
          class="pb-2 pr-2 w-full lg:w-1/2"
          label="Condición por cajas"
          type="number"
        />
        
        <text-input
          v-model="localDiscount"
          :error="errors[`discount${suffix ? '_' + suffix : ''}`]"
          class="pb-2 pr-2 w-full lg:w-1/2"
          :label="localType === 'Caja' ? 'Regalia en cajas' : 'Descuento en efectivo'"
          type="number"
          step="0.01"
        />
      </div>
    </div>
  </template>
  
  <script>
  import TextInput from '@/Shared/TextInput'
  
  export default {
    components: {
      TextInput
    },
    props: {
      type: String,
      condition: [String, Number],
      discount: [String, Number],
      errors: Object,
      suffix: {
        type: String,
        default: ''
      }
    },
    emits: ['update:type', 'update:condition', 'update:discount'],
    computed: {
      localType: {
        get() {
          return this.type
        },
        set(value) {
          this.$emit('update:type', value)
        }
      },
      localCondition: {
        get() {
          return this.condition
        },
        set(value) {
          this.$emit('update:condition', value)
        }
      },
      localDiscount: {
        get() {
          return this.discount
        },
        set(value) {
          this.$emit('update:discount', value)
        }
      }
    }
  }
  </script>